import { cn } from '@/lib/utils';

type SidebarBrandLogoProps = {
  /** Dark sidebars use the light-on-dark asset; light sidebars use the default brand PNG. */
  variant?: 'dark' | 'light';
  className?: string;
  compact?: boolean;
};

export function SidebarBrandLogo({ variant = 'dark', className, compact = false }: SidebarBrandLogoProps) {
  const src = variant === 'dark' ? '/logo-enthioshub-sidebar.png' : '/logo-enthioshub.png';

  return (
    <img
      src={src}
      alt="EnthiosHub"
      className={cn(
        'block object-contain select-none opacity-100 brightness-[1.12] contrast-[1.08] filter drop-shadow-[0_1px_2px_rgba(0,0,0,0.25)]',
        compact
          ? 'h-8 w-8 mx-auto object-center'
          : 'h-[52px] w-full max-w-[220px] object-left',
        className,
      )}
      draggable={false}
    />
  );
}
